import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

const WorkerDiscoveryNav = () => {
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const location = useLocation();
  const [searchParams] = useSearchParams();

  if (!isAuthenticated || user?.role !== 'worker') return null;

  const applicationStatuses = new Set([
    'applications',
    'application_opened',
    'applying',
    'applied',
    'auto_applied',
  ]);
  const isApplicationView = location.pathname === '/matches'
    && applicationStatuses.has(searchParams.get('status') || '');
  const tabs = [
    {
      label: 'For You',
      to: '/matches?status=matched',
      active: location.pathname === '/matches' && !isApplicationView,
    },
    {
      label: 'All Jobs',
      to: '/jobs',
      active: location.pathname === '/jobs' || location.pathname.startsWith('/jobs/'),
    },
    {
      label: 'Saved',
      to: '/saved-jobs',
      active: location.pathname === '/saved-jobs',
    },
    {
      label: 'Applied',
      to: '/matches?status=applications',
      active: isApplicationView,
    },
  ];

  return (
    <nav
      aria-label="Find work"
      className="mb-6 overflow-x-auto border-b border-gray-200"
    >
      <div className="flex min-w-max gap-1">
        {tabs.map((tab) => (
          <Link
            key={tab.label}
            to={tab.to}
            aria-current={tab.active ? 'page' : undefined}
            className={`border-b-2 px-4 py-3 text-sm font-semibold transition ${
              tab.active
                ? 'border-blue-600 text-blue-700'
                : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-900'
            }`}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default WorkerDiscoveryNav;
